import { Component, input, output } from '@angular/core';

/**
 * Layout shell for legacy-style detail filters: top toolbar (apply / clear / close),
 * three columns (left parameters, middle selected values, right saved filters).
 *
 * Project filter controls via `ng-content` using `klDetailFilterLeft`, `klDetailFilterMiddle`, `klDetailFilterRight`.
 */
@Component({
  selector: 'kl-detail-filter-shell',
  standalone: false,
  templateUrl: './kl-detail-filter-shell.html',
  styleUrl: './kl-detail-filter-shell.scss',
})
export class KlDetailFilterShell {
  readonly loading = input(false);
  readonly alertShow = input(false);
  readonly alertMessage = input('');

  /** i18n keys for toolbar column titles (legacy: filter values / saved filters). */
  readonly middleTitleKey = input('filter_values');
  readonly rightTitleKey = input('saved_filters');

  readonly applyLabelKey = input('filter');
  readonly clearLabelKey = input('clear');
  readonly closeLabelKey = input('close');

  /** Disabled icon button (e.g. save-as design) for parity with legacy toolbar. */
  readonly showSaveAsPlaceholder = input(false);
  readonly saveAsPlaceholderLabelKey = input('save_new_design');
  /** When true, shows loading state on the Apply toolbar button. */
  readonly applyBusy = input(false);
  /** When false, hides the right (saved filters) column and its toolbar title. */
  readonly showRight = input(true);

  readonly apply = output<void>();
  readonly clear = output<void>();
  readonly close = output<void>();
  readonly alertClose = output<void>();

  onApply(): void {
    this.apply.emit();
  }

  onClear(): void {
    this.clear.emit();
  }

  onClose(): void {
    this.close.emit();
  }
}
